module.exports = __webpack_public_path__ + "img/broken-heart.6f26ab73.svg";